import { Provider } from '@angular/core';
import { persistentPluginProviders } from './persistent';

export { StorePlugin, StorePluginFactory } from './abstract';
export { PersistentStorePlugin, PersistentStorePluginFactory } from './persistent';

export const pluginProviders: Provider[] = [...persistentPluginProviders];
